@if (isPreview()) {
    @if (imageEntities().length) {
        <div class="bazis-gallery-preview">
            @let image = imageEntities()[0].id | entity: 'uploadable.file_upload' | async;

            @if (image) {
                <div
                    class="bazis-figure"
                    (click)="openGallery(imageEntities(), 0)"
                >
                    <img
                        [src]="image.$snapshot.file"
                        [alt]="imagesAlt() ? imagesAlt()[0] : image.$snapshot.name"
                    />
                </div>
            } @else {
                <bazis-gallery-skeleton [isPreview]="isPreview()"></bazis-gallery-skeleton>
            }
            @if (imageEntities().length > 1) {
                <div class="bazis-gallery-preview__more"> + {{ imageEntities().length - 1 }} </div>
            }
        </div>
    }
} @else {
    <div
        class="bazis-list bazis-list_gallery"
        [ngClass]="[size() ? 'bazis-list_gallery_' + size() : '']"
    >
        @for (imageEntity of imageEntities(); track $index; let i = $index) {
            <div class="bazis-item">
                @let image = imageEntity.id | entity: 'uploadable.file_upload' | async;
                @if (image) {
                    <div
                        class="bazis-figure bh-pointer"
                        (click)="openGallery(imageEntities(), i)"
                    >
                        <img
                            [src]="image.$snapshot.file"
                            [title]="image.$snapshot.title"
                            [alt]="imagesAlt() ? imagesAlt()[i] : image.$snapshot.name"
                        />
                    </div>
                }
            </div>
        }
    </div>
}
